import classNames from 'classnames'
import React from 'react'
import {Divider} from '../../../../../../../commons/components/divider'
import c from '../../../classnames.scss'
import {BackToSiteLink} from '../../../common/back-to-site-link'
import {OrderSuccessProps} from '../interfaces'
import {Invoice} from './invoice'
import s from './mobile.scss'

export const Mobile = ({order, formattedOrderCreatedDate, t, orderHasSeats}: OrderSuccessProps) => (
  <div className={classNames(c.formLabelsColor, c.textFont)}>
    <div className={s.header}>
      <div className={s.orderNumber}>{t('ticketsThankYou.orderNo', {orderNumber: order.orderNumber})}</div>
    </div>
    <Divider />
    <div className={s.placedOn}>{t('ticketsThankYou.placedOn', {date: formattedOrderCreatedDate})}</div>
    <Divider />
    <Invoice orderHasSeats={orderHasSeats} order={order} />
    <Divider />
    <BackToSiteLink className={s.link} />
  </div>
)
